import { z } from "zod";

export const notificationTypeSchema = z.enum([
	"appointment_booked_by_patient",
	"appointment_reminder_24h",
	"appointment_cancelled",
	"appointment_no_show",
	"vital_critical",
	"radiology_critical",
	"results_ready",
	"visit_completed",
	"rx_dispensed",
	"system",
]);
export type NotificationType = z.infer<typeof notificationTypeSchema>;

export const notificationSeveritySchema = z.enum([
	"info",
	"success",
	"warning",
	"urgent",
]);
export type NotificationSeverity = z.infer<typeof notificationSeveritySchema>;

export interface NotificationApi {
	id: string;
	clinic_id: string;
	user_id: string | null;
	type: NotificationType;
	severity: NotificationSeverity;
	title: { ar: string; en?: string };
	body: { ar?: string; en?: string } | null;
	link_path: string | null;
	external_url: string | null;
	resource_type: string | null;
	resource_id: string | null;
	metadata: Record<string, unknown> | null;
	read_at: string | null;
	created_at: string;
}

export const notificationsListQuerySchema = z.object({
	unread_only: z.coerce.boolean().optional(),
	limit: z.coerce.number().int().positive().max(100).default(30),
});
export type NotificationsListQuery = z.infer<
	typeof notificationsListQuerySchema
>;

export interface NotificationsListResponse {
	items: NotificationApi[];
	unread_count: number;
}
